// extracted by mini-css-extract-plugin
export default {"icon-wrap":"viridius-icon_icon-wrap__zcPzp","sphere1":"viridius-icon_sphere1__g0W+A","sphere2":"viridius-icon_sphere2__xO-OP"};